module.exports = __webpack_public_path__ + "static/media/medice.257f4a85.svg";